// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R35qz","col":"styles_col__NJl5A"};